/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from "@angular/core";
import { StationDto } from "src/app/services/api";
import { OrderStationsByWaterLevelPipe } from "../order-stations-by-water-level/order-stations-by-water-level.pipe";

@Pipe({ name: "orderStationsByAlertLevel" })
export class OrderStationsByAlertLevelPipe implements PipeTransform {
  public transform(elements: StationDto[]): StationDto[] {
    if (!elements) return [];
    return ([...elements] || []).sort((a, b) => this.orderStationsByAlertLevel(a, b));
  }

  private isNumber(value: any): boolean {
    return typeof value === "number" && value !== null;
  }

  public orderStationsByAlertLevel(a: StationDto, b: StationDto): number {
    if (!this.isNumber(a.alertLevel) && !this.isNumber(b.alertLevel)) return a.id.localeCompare(b.id);
    else if (!this.isNumber(a.alertLevel)) return 1;
    else if (!this.isNumber(b.alertLevel)) return -1;

    const result = b.alertLevel - a.alertLevel;
    const orderByWaterLevel = new OrderStationsByWaterLevelPipe();

    return result ? result : orderByWaterLevel.sortStationsByWaterLevel(a, b);
  }
}
